/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var RankByValues;
(function (RankByValues) {
    RankByValues["REVIEW_NUM"] = "review_num";
    RankByValues["RATING_NUM"] = "rating_num";
    RankByValues["RATING_SCORE"] = "rating_score";
    RankByValues["RATING"] = "rating";
})(RankByValues || (RankByValues = {}));
